import React, { FC } from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

interface Props {
  /** Complete path to the article, without the domain name */
  articlePath: string
}

/**
 * This component allows links within MDX files to be publication-dependent.
 */
export const ArticleLink: FC<Props> = ({ articlePath, children }) => (
  <a href={`https://www.${parseHostname().publicationDomain}${articlePath}`}>
    <i className='small external link icon' />
    {children}
  </a>
)
